import { useEffect, useRef, useState } from 'react';
import { Controller } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import MaskedInput from 'react-input-mask';
import { validarCedulaReclutamiento } from '../../redux/Empleados/EmpleadosSlice';

export const CedulaReclutamientoForm = ({ control, trigger, clearErrors, disabled = false }) => {
  const dispatch = useDispatch();
  const [consultando, setConsultando] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const ultima = useRef({ id: 0, promesa: Promise.resolve(true) });
  const montado = useRef(true);
  const nombre = 'empleado.cedula';

  useEffect(() => { montado.current = true; return () => { montado.current = false; }; }, []);

  const validar = (valor) => {
    const cedula = (valor ?? '').replace(/[-\s]/g, '');
    const id = ultima.current.id + 1;
    setMensaje('');
    if (!/^[0-9]{11}$/.test(cedula)) {
      ultima.current = { id, promesa: Promise.resolve('La cédula debe tener 11 dígitos.') };
      setConsultando(false);
      return ultima.current.promesa;
    }

    setConsultando(true);
    const promesa = dispatch(validarCedulaReclutamiento(cedula)).unwrap()
      .then((respuesta) => {
        if (id !== ultima.current.id) { return ultima.current.promesa; }
        const resultado = respuesta.data.puedeReclutar === true ? true : respuesta.message || 'El empleado ya existe.';
        if (montado.current && resultado === true) { setMensaje('Cédula disponible para reclutamiento.'); }
        return resultado;
      })
      .catch((error) => id !== ultima.current.id ? ultima.current.promesa :
        typeof error === 'string' ? error : 'No se pudo validar la cédula. Intente nuevamente.')
      .finally(() => {
        if (montado.current && id === ultima.current.id) { setConsultando(false); }
      });
    ultima.current = { id, promesa };
    return promesa;
  };

  return (
    <div className="form-group">
      <label className="fw-bold" htmlFor={nombre}>Cédula</label>
      <Controller
        name={nombre}
        control={control}
        defaultValue=""
        rules={{ required: 'La cédula es requerida', validate: validar }}
        render={({ field, fieldState }) => (
          <>
            <MaskedInput
              id={nombre}
              mask="999-9999999-9"
              maskChar=""
              value={field.value}
              disabled={disabled}
              onChange={(event) => {
                ultima.current = { id: ultima.current.id + 1, promesa: Promise.resolve(true) };
                setConsultando(false);
                setMensaje('');
                clearErrors(nombre);
                field.onChange(event);
              }}
              onBlur={() => {
                field.onBlur();
                trigger(nombre);
              }}

            >
              {(inputProps) => <input {...inputProps} ref={field.ref} className="form-control" type="text" aria-invalid={!!fieldState.error} aria-describedby="validacion-cedula" />}
            </MaskedInput>
            <div id="validacion-cedula" aria-live="polite">
              {consultando && <p className="text-muted">Validando cédula...</p>}
              {fieldState.error && <p className="text-danger">{fieldState.error.message}</p>}
              {!consultando && !fieldState.error && mensaje && <p className="text-muted">{mensaje}</p>}
            </div>
          </>
        )}
      />
    </div>
  );
};